import commonService from './common-service';

class StockService {
  async addDrg(params){
    try {
      let response = await commonService.postToServer('Stocks/Drugs', params);
      if (response) {  
        let resp = {
          code:200
        }      
        return resp;
      } else {
        throw new Error('Error');
      }
    } catch (e) {
      return e;
    }
  }
  async getFacByParent(parentId){
    try {
      const response = await commonService.getFromServer('Stocks/Facilities?parent='+parentId, {});
      if (response) {
        return response;
      } else {
        throw new Error('Error retrieving facilities. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getDrugList(drgName){
    try {
      const response = await commonService.getFromServer('Stocks/Drugs?name='+drgName, {});      
      if (response) {
        return response;
      } else {
        throw new Error('Error retrieving facilities. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getMasterDrugList(parentId,facId){
    try {
      const response = await commonService.getFromServer('Stocks?parent='+parentId+'&fac_id='+facId, {});      
      if (response) {
        return response;
      } else {
        throw new Error('Error retrieving Master Drugs List. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getParent() {
    try {
      const response = await commonService.getFromServer('Stocks/Parents', {});
      if (response) {
        return response;
      } else {
        throw new Error('Error loading carriers');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  } 
  async deleteDrg(drugId){
    try {
      const response = await commonService.deleteToServer('Stocks/Drugs/'+drugId, {});      
      if (response) {
        return response;
      } else {
        throw new Error('Error while deleting Drug. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async editDrg(params){
    try {
      const response = await commonService.postToServer('Stocks/Drugs', params);      
      if (response) {
        return response;
      } else {
        throw new Error('Error while editing drug. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async saveQuantity(drugDetails){
    try {
      const response = await commonService.postToServer('Stocks', drugDetails);      
      if (response) {
        return response;
      } else {
        throw new Error('Error in saving quantity. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async assignDr(params){
    try {
      const response = await commonService.postToServer('Stocks/Doctors', params);      
      if (response) {
        return response;
      } else {
        throw new Error('Error in saving quantity. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  } 
  async getDoctors(){
    try {
      const response = await commonService.getFromServer('Stocks/Doctors', {});
      if (response) {
        return response;
      } else {
        throw new Error('Error loading carriers');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }  
  async getSelectedDoc(fid){
    try {
      const response = await commonService.getFromServer('Stocks/Doctors/'+fid, {});
      if (response) {
        return response;
      } else {
        return {}
      }
    } catch (e) {

      throw new Error(e.message);
    }
  } 
  async getStockRep(params){
    try {
      const response = await commonService.getFromServer('Stocks/Report', params);      
      if (response) {
        return response;
      } else {
        throw new Error('Error in saving quantity. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async cpyParents(params){
    try {
      const response = await commonService.postToServer('Stocks/CopyParent?source='+params.source+'&target='+params.target, {});      
      if (response) {
        return response;
      } else {
        throw new Error('Error in copying drugs. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async cpyfrmFacility(params){
    try {
      const response = await commonService.postToServer('Stocks/CopyFacility?parent='+params.parent+'&source='+params.source+'&target='+params.target, {});      
      if (response) {
        return response;
      } else {
        throw new Error('Error in copying drugs. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
}
export default new StockService();
